import "../Main.scss";
import "./Notice.scss";
import "../../lib/form/form.scss";
import "./Standard.scss";
import Sub from "../Sub";

import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { FiSearch } from "react-icons/fi";
// import NoticeDetail from "./NoticeDetail";
import { useEffect } from "react";
import axios from "axios";
import Pagination from "react-js-pagination";
import StandardDetail from "./StandardDetail";
import ConfirmModal from "../../components/ConfirmModal";

function Standard() {
  const location = useLocation();
  const [disNum, setDisNum] = useState([]);
  const [category, setCategory] = useState(location?.state?.category);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [filterType, setFilterType] = useState("init");
  const [filterInput, setFilterInput] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [filterValidateModal, setFilterValidateModal] = useState(false);

  let navigate = useNavigate();
  const onClickFilter = () => {
    // console.log(`onClick filterType = ${filterType}`);
    // console.log(`onClick filterInput = ${filterInput}`);
    if (filterType === "init") {
      // alert("검색필터를 선택하세요.");
      setFilterModal(true);
      setFilterInput("");
      posts();
    } else if (filterType === "nameLike" && filterInput.length === 0) {
      setFilterValidateModal(true);
    } else if (filterType === "manageNumLike" && filterInput.length === 0) {
      setFilterValidateModal(true);
    } else {
      setPage(0);
      PageFilterReplace();
    }
  };
  const PageFilterReplace = () => {
    // console.log(`page = ${page}`);
    posts();
  };
  const handlePageChange = (page) => {
    posts(page);
    setPage(page);
  };
  // const openModal = (e) => {
  //   e.preventDefault();
  //   setFilterModal(true);
  // };
  const closeModal = (e) => {
    e.preventDefault();
    setFilterModal(false);
    setFilterValidateModal(false);
  };

  let posts = function (pageNum) {
    if (pageNum === undefined) pageNum = 1;

    let params = {
      pageNumber: pageNum,
      category: category,
      pageSize: 15,
      sortField: "updateAt",
      sortOrder: "desc",
    };
    let searchSelect = filterType;
    if (searchSelect !== "init") {
      params[searchSelect] = filterInput;
    }
    // console.log(params);
    axios.get("/api/examguide", { params }).then((response) => {
      setDisNum(response.data.data);
      // setRecords(response.data);
      setTotalItems(response.data.recordsFiltered);
    });
  };

  // 날짜 => 숫자, 상시
  useEffect(() => {
    if (location.state !== null) {
      setCategory(location.state.category);
    }
    posts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  const onChangeFilterInput = (e) => {
    // console.log(e.target.value);
    setFilterInput(e.target.value);
  };
  const onChangeFilterType = (e) => {
    setFilterType(e.target.value);
  };
  const onChangeHandler = async (event) => {
    const response = await axios.get("/api/examguide", {
      params: {
        pageNumber: page,
        category: event.target.value,
        pageSize: 5,
        sortField: "updateAt",
        sortOrder: "desc",
      },
    });
    setDisNum(response.data.data);
    setCategory(event.target.value);
    setTotalItems(response.data.recordsFiltered);
    navigate("/standard");
    // console.log(category);
  };

  return (
    <>
      {filterModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색 필터"}
          content={`검색 필터를 선택해 주세요.`}
        />
      ) : null}
      {filterValidateModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"검색어 입력"}
          content={`검색어를 입력해 주세요.`}
        />
      ) : null}
      <Sub to={"/standard"} title="기준" />
      <div className="">
        <div className=" ">
          <form className="my_page bbs_contain" action="" method="">
            <div className="row_bbs">
              <div className="select_box">
                <select
                  defaultValue={
                    category === 0
                      ? "0"
                      : category === 1
                      ? "1"
                      : category === 2
                      ? "2"
                      : category === 3
                      ? "3"
                      : ""
                  }
                  name="fruites1"
                  onChange={onChangeHandler}
                >
                  <option value="">전체</option>

                  <option value="0">인증기준</option>

                  <option value="1">인정기준</option>

                  <option value="2">시험기준</option>

                  <option value="3">민간지원기준</option>
                </select>
              </div>
              <div className="select_box">
                <select
                  defaultValue={"init"}
                  name="fruites"
                  onChange={onChangeFilterType}
                >
                  <option value="init" disabled>
                    검색필터
                  </option>
                  <option value="nameLike">제목</option>
                  <option value="manageNumLike">기준번호</option>
                </select>
              </div>

              <div className="input_wrap">
                <input
                  className="input_box"
                  type="text"
                  placeholder="검색어를 입력하세요."
                  value={filterInput}
                  onChange={onChangeFilterInput}
                />
                <button
                  type="button"
                  className="btn_color"
                  onClick={onClickFilter}
                >
                  <FiSearch />
                </button>
              </div>
            </div>

            <Routes>
              <Route path=":id" element={<StandardDetail />} />
            </Routes>

            <div className="row_bbs bbs_wrap">
              <table className="table_wrap standard_table_wrap">
                <thead>
                  <tr>
                    <th style={{ flex: "0.2" }}>심사구분</th>
                    <th style={{ flex: "0.5" }}>심사기준명</th>
                    <th style={{ flex: "0.3" }}>심사기준번호</th>
                    <th style={{ flex: "0.1" }}>제·개정일</th>
                  </tr>
                </thead>
                {disNum.length > 0 ? (
                  <tbody>
                    {disNum.map((disNumInfo) => {
                      // 게시글 번호 => 숫자, 상시
                      return (
                        <tr className="tr_hover" key={disNumInfo.id}>
                          <td style={{ flex: "0.2" }} className="num_bbs">
                            {disNumInfo.targetName}
                          </td>
                          <td style={{ flex: "0.5" }}>
                            <p
                              onClick={() => {
                                window.scrollTo(0, 0);
                                navigate(`/standard/${disNumInfo.id}`);
                              }}
                            >
                              {disNumInfo.name}
                            </p>
                          </td>
                          <td style={{ flex: "0.3" }}>
                            <p className="auth">{disNumInfo.manageNum}</p>
                          </td>
                          <td style={{ flex: "0.1" }} className="date_bbs">
                            {disNumInfo.updateAt
                              .substring(0, 11)
                              .replace(/-/g, ".")}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : null}
              </table>
              {disNum.length > 0 ? null : (
                <span style={{ textAlign: "center", marginTop: "10vh" }}>
                  등록된 목록이 없습니다
                </span>
              )}
              <div className="pagination_wrap">
                <div></div>

                <div className="pagination">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={15}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={15}
                    onChange={handlePageChange}
                    prevPageText={"‹"}
                    nextPageText={"›"}
                  />
                </div>
                <div>
                  {/* <button
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/standard");
                    }}
                    className="list_btn"
                  >
                    목록
                  </button> */}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Standard;
